import React from "react";
import { ClientEntityType } from "@/lib/supabase/supabaseTypes";
import {
	getClientInitials,
	getClientDisplayName,
} from "@/lib/utils/client-utils";
import { cn } from "@/dentlab/src/lib/util";

interface ClientInitialsAvatarProps {
	client: ClientEntityType & { image_src?: string };
	expanded: boolean;
	showCode?: boolean;
}

export const ClientInitialsAvatar: React.FC<ClientInitialsAvatarProps> = ({
	client,
	expanded,
	showCode = false,
}) => {
	const displayText =
		showCode && client?.code
			? expanded
				? client.code.slice(0, 10)
				: client.code.slice(0, 2)
			: getClientInitials(
					client.first_name,
					client.last_name,
					client.company_name,
					client.is_company
				);

	const getBackgroundColor = (name: string) => {
		const mutedColors = [
			"#950952",
			"#5E0035",
			"#023618",
			"#005C69",
			"#BF8B85",
			"#AD8A64",
			"#721121",
			"#A5402D",
			"#A49E8D",
			"#504136",
			"#689689",
			"#272838",
			"#5D536B",
			"#7D6B91",
			"#347FC4",
			"#B98B82",
			"#37515F",
			"#9899A6",
			"#AA78A6",
			"#824670",
			"#A2708A",
			"#629460",
		];

		let hash = 0;
		for (let i = 0; i < name.length; i++) {
			hash = name.charCodeAt(i) + ((hash << 5) - hash);
		}

		const index = Math.abs(hash % mutedColors.length);
		return mutedColors[index];
	};

	const bgColor = getBackgroundColor(getClientDisplayName(client));

	return (
		<div
			className={cn(
				"flex items-center justify-center text-white font-medium rounded-sm flex-shrink-0",
				showCode && expanded && !client.image_src
					? "px-1.5 py-1 h-[22px]"
					: "w-[22px] h-[22px]"
			)}
			style={{
				backgroundColor: bgColor,
			}}
		>
			{client.image_src &&
			client?.image_src?.split("/")[0] !== "public" ? (
				<img
					src={client.image_src}
					alt="Client"
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
						borderRadius: "2px",
					}}
				/>
			) : (
				<span
					style={{
						fontSize: "11px",
						lineHeight: 1,
					}}
				>
					{displayText}
				</span>
			)}
		</div>
	);
};
